export enum Role {
  DANCER = 'Dancer authenticated',
  PUBLIC = 'Public',
  SUPER_ADMIN = 'Super Admin',
  SCHOOL = 'School authenticated',
}
